import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Helmet } from 'react-helmet-async';

import { RouterLink } from '@src/components/core/link';
import config from '@src/config';


const metadata = {title: `Internal server error | ${config.SITE.title}`};

function Page500() {
  return (
    <>
      <Helmet>
        <title>{metadata.title}</title>
      </Helmet>
      <Box
        component="main"
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minHeight: '100%',
          py: '64px',
        }}
      >
        <Container maxWidth="lg">
          <Stack spacing={6}>
            <Box sx={{display: 'flex', justifyContent: 'center'}}>
              <Box
                alt="Internal server error"
                component="img"
                src="/assets/not-found.svg"
                sx={{height: 'auto', maxWidth: '100%', width: '200px'}}
              />
            </Box>
            <Stack spacing={1} sx={{textAlign: 'center'}}>
              <Typography variant="h4">500: Internal server error</Typography>
              <Typography color="text.secondary">
                Error had occurred on the processing this request. Please apply to <a href="mailto:support@softformance.com">support@softformance.com</a> to investigate this case.
              </Typography>
            </Stack>
            <Box sx={{display: 'flex', justifyContent: 'center'}}>
              <Button component={RouterLink} href="/" variant="contained">
                Back to home
              </Button>
            </Box>
          </Stack>
        </Container>
      </Box>
    </>
  );
}

Page500.displayName = 'Page500';
export default Page500;
